import StoreClass from 'icons/shop/store-class.svg';
import { toQueryString } from 'libs/utils';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ShopIndexPageData } from 'pages/shop/index/[shopSysNo]';
import { useEffect, useRef, useState } from 'react';
import { cls } from 'reactutils';
import ProductListComp from 'comps/h5/Search/components/ProductList';
import SearchInput from './SearchInput';
import ShopInfoHead from './ShopInfoHead';

export default function ShopIndexContentH5(props: ShopIndexPageData) {
  const router = useRouter();
  const query = router.query || {};
  const shopSysNo = query.shopSysNo as string;
  const [shopInnerTab, setShopInnerTab] = useState(2);
  const [toolHeight, setToolHeight] = useState(0);
  const toolRef = useRef<HTMLDivElement>();
  const [condition, setCondition] = useState({ key: '', shopInnerTab: 2 });

  useEffect(() => {
    setToolHeight(toolRef.current.clientHeight);
    const sessionDataStr = sessionStorage[window.location.pathname];
    const sessionData = sessionDataStr ? JSON.parse(sessionDataStr) : {};
    if (sessionData.condition?.shopInnerTab) {
      setShopInnerTab(sessionData.condition?.shopInnerTab);
    }
  }, []);

  function handleSearch(key) {
    pushListPage({
      key,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  function pushListPage(condition = {}) {
    router.push(
      `/product/list${toQueryString({
        ...condition,
        shopSysNo,
      })}`,
    );
  }

  return (
    <div>
      <div ref={toolRef}>
        <SearchInput isSearchSku placeholder="搜索店铺内商品" onSearch={handleSearch} />
        <ShopInfoHead {...props.shopInfo} />
        {props.supplierLimitEnable && (
          <div className="tip-wrap">
            该供应商已被限制平台交易，您可以继续浏览店铺或商品，但不能向供应商下单。
          </div>
        )}
        <div className={cls('tabs-wrap', shopInnerTab === 2 && 'tabs-wrap-hot')}>
          <div className="tabs-left">
            <div className="active-line" style={{ left: shopInnerTab === 2 ? '7px' : '78px' }} />
            <div
              className={cls('tab-item', shopInnerTab === 2 && 'active')}
              onClick={() => {
                setCondition((v) => ({ ...v, shopInnerTab: 2 }));
                setShopInnerTab(2);
              }}
            >
              热销
            </div>
            <div
              className={cls('tab-item', shopInnerTab === 1 && 'active')}
              onClick={() => {
                setCondition((v) => ({ ...v, shopInnerTab: 1 }));
                setShopInnerTab(1);
              }}
            >
              全部商品
            </div>
          </div>
          <Link href={`/shop/category/${shopSysNo}`}>
            <a className="tabs-right">
              <StoreClass />
            </a>
          </Link>
        </div>
      </div>

      <ProductListComp
        toolHeight={shopInnerTab === 2 && toolHeight ? toolHeight + 16 : toolHeight}
        shopSysNo={shopSysNo}
        pCondition={condition}
        showCondition={shopInnerTab === 1}
      />
      <style jsx>{`
        .tabs-wrap {
          background-color: #fff;
          height: 46px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px;
        }
        .tabs-wrap.tabs-wrap-hot {
          box-shadow: 0 4px 7px -3px rgb(0 0 0 / 13%);
          margin-bottom: 16px;
        }
        .tabs-left {
          display: flex;
          align-items: center;
          position: relative;
        }
        .tab-item {
          margin-right: 25px;
          font-size: 15px;
          color: #666666;
          line-height: 30px;
        }
        .tab-item.active {
          color: var(--primaryColor);
          font-weight: bold;
        }
        .active-line {
          width: 15px;
          height: 2px;
          background-color: var(--primaryColor);
          position: absolute;
          bottom: 0;
          transition: all 0.2s;
        }
        .tabs-right {
          height: 15px;
        }
        .tip-wrap {
          padding: 10px 14px 10px 16px;
          background: #ffeae0;
          font-size: 12px;
          color: #f5222d;
          line-height: 18px;
        }
      `}</style>
    </div>
  );
}
